import React, { useEffect, useState } from 'react'
import { AttachmentDataWithRequiredAttachment } from '../../../../../../../../../../@types/types'
import MultimediaDetailsModal from '../../../../multimediaDetailsModal/modal/MultimediaDetailsModal'

interface BulkEditMultimediaModalProps {
  attachments: AttachmentDataWithRequiredAttachment[]
  initialAttachmentIndex: number
  isOpen: boolean
  closeModal: () => void
  onTitleChange: (attachment: AttachmentDataWithRequiredAttachment) => void
}

export const BulkEditMultimediaModal: React.FC<BulkEditMultimediaModalProps> = ({
  attachments,
  initialAttachmentIndex,
  isOpen,
  closeModal,
  onTitleChange,
}) => {
  const [attachmentIndex, setAttachmentIndex] = useState(initialAttachmentIndex)
  const [modalAttachments, setModalAttachments] = useState(attachments)
  const lastAttachmentIndex = modalAttachments.length - 1

  useEffect(() => {
    if (isOpen) {
      setAttachmentIndex(initialAttachmentIndex)
      setModalAttachments(attachments)
    }
  }, [attachments, initialAttachmentIndex, isOpen])

  if (modalAttachments.length === 0) {
    return null
  }

  const handleTitleChange = (attachment: AttachmentDataWithRequiredAttachment) => {
    setModalAttachments((currentAttachments) =>
      currentAttachments.map((currentAttachment) =>
        currentAttachment.attachment.id === attachment.attachment.id ? attachment : currentAttachment
      )
    )
    onTitleChange(attachment)
  }

  return (
    <MultimediaDetailsModal
      attachments={modalAttachments}
      attachmentIndex={attachmentIndex}
      onTitleChange={handleTitleChange}
      onFloorPlanStatusChange={() => {}}
      onDelete={() => {}}
      isOpen={isOpen}
      closeModal={closeModal}
      onPreviousImage={() => setAttachmentIndex((index) => index - 1)}
      onNextImage={() => setAttachmentIndex((index) => index + 1)}
      showButtonPreviousImage={attachmentIndex > 0}
      showButtonNextImage={attachmentIndex < lastAttachmentIndex}
      showReadyButton={false}
    />
  )
}
